import React from "react";
import {Box} from "@mui/system";
import {Route, Routes} from "react-router-dom";

import HeaderAppbar from "../components/HeaderAppbar";
import NavBar from "../components/NavBar";
import MWSnackbar from "../components/MWSnackbar";
import MWAlertDialog from "../components/MWAlertDialog";
import Education from "./Education";
import Equipment from "./Equipment";
import DashboardChart from "../temp/DashboardChart";
import MWProgress from "../components/MWProgress";
import WorkOrder from "./WorkOrder";
import Statistics from "./Statistics";
import Archive from "./Archive";
import Document from "./Document";
import Department from "./Department";
import Officer from "./Officer";
import MWExtraAlert from "../components/MWExtraAlert";
import Home from "./Home";
import Permission from "./Permission";
import {QueryCache, QueryClient} from "react-query";
import Board from "./Board";
import Post from "./Post";
import Manual from "../container/manual/Manual";
import BoardManager from "./BoardManager";
import Company from "./Company";
import Manager from "./Manager";
import NotFound from "./NotFound";
import Suggestion from "./Suggestion";
import ProtectLayout from "../layout/ProtectLayout";
import ArchiveList from "../container/archive/ArchiveList";
import CreateFolder from "../container/archive/CreateFolder";
import UpdateFolder from "../container/archive/UpdateFolder";

const MainPage = () => {
  return (
    <>
      <HeaderAppbar />
      <NavBar />
      <Box sx={{padding: {xs: "12px 8px", md: "24px 40px"}}}>
        <Routes>
          <Route path="/*" element={<ProtectLayout />}>
            <Route path="Home/*" element={<Home />} />

            {/* <Route path="Company/*" element={<Company />} />
            <Route path="Manager/*" element={<Manager />} />
            <Route path="Suggestion/*" element={<Suggestion />} />

            <Route path="BoardManager/*" element={<BoardManager />} />

            <Route path="Department/*" element={<Department />} />
            <Route path="Officer/*" element={<Officer />} />
            <Route path="Equipment/*" element={<Equipment />} />
            <Route path="Education/*" element={<Education />} />
            <Route path="WorkOrder/*" element={<WorkOrder />} />
            <Route path="Statistics/*" element={<Statistics />} />
            <Route path="Document/*" element={<Document />} />
            <Route path="Permission/*" element={<Permission />} />
            <Route path="Board/*" element={<Board />} />
            <Route path="Post/*" element={<Post />} />
            <Route path="Manual" element={<Manual />} />
            <Route path="Archive/" element={<ArchiveList />} />
            <Route path="Archive/:id" element={<ArchiveList />} />
            <Route path="Archive/Create/:id" element={<CreateFolder />} />
            <Route path="Archive/Edit/:id" element={<UpdateFolder />} /> */}
            <Route path="/*" element={<NotFound />} />
          </Route>
        </Routes>
        <MWAlertDialog />
        <MWSnackbar />
        <MWExtraAlert />
      </Box>
    </>
  );
};

export default MainPage;
